
import { Base64 } from 'js-base64'
import WeaLocaleProvider from '../wea-locale-provider';

const Base64WithLocale = {...Base64, decode: function(str) {
  let base64Str = Base64.decode(str);
  return WeaLocaleProvider.formatMultiLang(base64Str);
}};
export default Base64WithLocale;



// WEBPACK FOOTER //
// ./ecology9/wea-tools/base64.js